import './propertyAccessNotice.css';

let errorNotice;
let noticeTimer;

export function clearPropertyAccessError() {
  clearInterval(noticeTimer);
  errorNotice?.remove();
  // Older prerenders may contain a notice outside React's root. A successful
  // live request must clear those stale notices as well as this module's notice.
  document.querySelectorAll('.idx-property-notice').forEach(notice => notice.remove());
  errorNotice = null;
}

export function showPropertyAccessError(error) {
  clearPropertyAccessError();
  errorNotice = document.createElement('section');
  errorNotice.className = 'idx-property-notice';
  errorNotice.setAttribute('aria-label', 'Property browsing status');
  const message = document.createElement('p');
  message.setAttribute('role', 'alert');
  const dismiss = document.createElement('button');
  dismiss.type = 'button';
  dismiss.textContent = 'Dismiss';
  let remaining = Math.max(0, Math.ceil(error.retryAfter || 0));
  const updateNotice = () => {
    if (remaining <= 0) {
      clearPropertyAccessError();
      return;
    }
    message.textContent = `${error.message} You can retry in ${remaining}s.`;
    remaining -= 1;
  };
  if (remaining > 0) {
    updateNotice();
    noticeTimer = setInterval(updateNotice, 1000);
  } else {
    message.textContent = error.message;
  }
  dismiss.onclick = clearPropertyAccessError;
  errorNotice.append(message, dismiss);
  document.body.appendChild(errorNotice);
}
